const tmpBox = new THREE.Box3(), tmpQuaternion = new THREE.Quaternion();
const tmpMatrix = new THREE.Matrix4(), tmpInverse = new THREE.Matrix4();
const tmpScale = new THREE.Vector3(), tmpPosition = new THREE.Vector3();
const tmpTarget = new THREE.Vector3();
const geometry = new THREE.CircleBufferGeometry(0.5, 16);
const mesh = new THREE.Mesh(geometry, null);

geometry.isReady = false;

function getExtendedObject(object, camera, extendedSize) {
    if (object.geometry.boundingSphere)
        object.geometry.computeBoundingSphere();

    object.geometry.boundingSphere
        .getBoundingBox(tmpBox)
        .getSize(tmpScale)
        .multiply(object.scale)
        .multiplyScalar(extendedSize);

    tmpPosition
        .copy(object.geometry.boundingSphere.center)
        .applyMatrix4(object.matrix);

    tmpInverse.getInverse(object.parent.matrixWorld);

    tmpTarget
        .copy(camera.position)
        .applyMatrix4(camera.parent.matrixWorld)
        .applyMatrix4(tmpInverse);

    tmpMatrix.lookAt(tmpPosition, tmpTarget, THREE.Object3D.DefaultUp)

    tmpQuaternion.setFromRotationMatrix(tmpMatrix);
    mesh.matrix.compose(tmpPosition, tmpQuaternion, tmpScale);
    mesh.matrixWorld.multiplyMatrices(object.parent.matrixWorld, mesh.matrix);
    mesh.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, mesh.matrixWorld);
    mesh.normalMatrix.copy(object.modelViewMatrix);

    return mesh;
}

function getExtendedGeometry() { return geometry; }

export default getExtendedObject;
export { getExtendedGeometry, getExtendedObject };